(ns common.widgets.auth-card
  (:require ["@mui/material/Card$default" :as Card]
            ["@mui/material/CardActions$default" :as CardActions]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.logo :as logo]
            [reitit.frontend.easy :as r.easy]
            [uix.core :refer [defui $]]))

(defui auth-card [{:keys [sub-title on-submit return novalidate children]
                   :or {return :common/login}}]
  ($ Card {:sx #js {:width "380px"
                    :mt "15%"
                    :alignSelf "center"
                    :p 4
                    :gap 3
                    :backgroundColor (fn [^js theme]
                                       (when (= (.. theme -palette -mode) "dark")
                                         "grey.70"))}}
     ($ Stack
        {:direction "row"
         :justifyContent "center"
         :alignItems "center"
         :gap 1.5}
        ($ logo/activation-logo
           {:width 40
            :height 40})
        ($ Typography
           {:fontSize "lg"
            :fontWeight 600
            :color "initial"}
           "Creative Optimizations"))
     (when sub-title
       ($ Typography
          {:fontWeight 600
           :textAlign "center"}
          sub-title))
     ($ Divider)
     ($ Stack
        (cond-> {:spacing 2}
          novalidate (assoc :noValidate true)
          on-submit (assoc :component "form"
                           :on-submit (fn [e]
                                        (.preventDefault e)
                                        (on-submit))))
        children)
     ($ Divider)
     ($ Stack {:gap 1}
        ($ Typography
           {:variant "body2"
            :font-weight "400"}
           "One account for all WPP applications with WPP Okta")
        ($ CardActions {:sx #js {:justifyContent "center"
                                 :p 0}}
           ($ Link {:href "https://www.choreograph.com/global-privacy-policy/global-privacy-policy-english/"
                    :target "_blank"
                    :color "text.primary"
                    :underline "hover"
                    :sx #js {:fontWeight 600}
                    :data-testid "privacy-policy-button"}
              "Privacy policy")
           ($ Link {:href (r.easy/href :common/tac nil {:return return})
                    :color "text.primary"
                    :underline "hover"
                    :sx #js {:fontWeight 600}
                    :data-testid "terms-conditions-button"}
              "Terms and conditions")))))
